import SunvegaAPI from '@api/clouddesign'
// @ts-ignore
import semverCompare from 'semver/functions/compare'
import { getValueFromSearchParams, isIn3D } from './utils'
const { Core, UI, Common } = SunvegaAPI

let isNewClouddesign: boolean = false

const hostname: string = window?.location?.href || '';
let env = 'prod';
if (hostname.indexOf('pre-') > -1) {
  env = 'pre';
} else if (hostname.indexOf('hws-') > -1) {
  env = 'hws';
} else if (hostname.indexOf('dev-plugin-test') > -1) {
  env = 'test';
}

/**
 * @description 初始化SunvegaAPI，请在项目入口文件调用
 * @param name api唯一标识，建议使用package.json->name
 */
export const init = async (name: string) => {
  await Core.APIManager.init(`sunvega-material-${name}`);
  const res = await Common.Framework.getVersions(undefined, {
    timeout: 300 // 超时时间
  });
  const data: any = res?.data || {};
  const limitVersion = '1.15.31';
  // 1.15.31 版本后，支持openMessage等API
  if ((data.apiVersion && semverCompare(data.apiVersion, limitVersion) >= 0) || Number(getValueFromSearchParams('expandIframeWidth'))) {
    isNewClouddesign = true;
  }
}

/**
 * @description 判断是否在新的云设计中（支持openMessage等API）
 * @returns 
 */
export const isInNewClouddesign = () => {
  return isIn3D && isNewClouddesign;
}

export interface MessageProps {
  /** 内容 */
  content: string;
  /** 类型 */
  type?: 'info' | 'success' | 'warning' | 'error' | 'loading';
  /** 自动关闭的延时，单位秒 */
  duration?: number;
  /** 当前提示的唯一标志 */
  key?: string;
}

/**
 * @description 打开消息提示
 * @param props 
 */
export const openMessage = async (props: MessageProps) => {
  UI.Basic.openMessage(props)
}
